export default function ResidentialRemodelingFAQ() {
  const faqs = [
    {
      question: 'How much does a home remodeling project cost in El Paso?',
      answer: 'Remodeling costs vary widely based on project scope and materials. Kitchen remodels range $25,000-$75,000, bathroom renovations $8,000-$40,000, and room additions $100-$300 per square foot. Whole home remodels typically cost $100,000-$300,000+. Get detailed written estimates from multiple contractors to compare pricing. Quality materials and experienced contractors cost more upfront but provide better long-term value.'
    },
    {
      question: 'How long does a typical remodeling project take?',
      answer: 'Timeline depends on project complexity. Bathroom renovations take 2-4 weeks, kitchen remodels 4-8 weeks, room additions 8-12 weeks, and whole home renovations 3-6 months. Factors affecting timeline include permit approval, material availability, weather, and unexpected issues discovered during demolition. Professional contractors provide realistic schedules with milestone dates.'
    },
    {
      question: 'Do I need permits for remodeling in El Paso?',
      answer: 'Most remodeling projects require building permits from the City of El Paso. Permits are needed for structural changes, electrical work, plumbing modifications, room additions, and major renovations. Minor cosmetic updates like painting or flooring may not require permits. Reputable contractors handle all permitting as part of their service. Never skip permits—they ensure safety and protect your home value.'
    },
    {
      question: 'Should I stay in my home during remodeling?',
      answer: 'This depends on project scope and your tolerance for disruption. Kitchen and bathroom remodels can be managed while living at home, though expect noise, dust, and limited access to those areas. Whole home renovations often require temporary relocation. Discuss logistics with your contractor—they can schedule work to minimize disruption and maintain livable spaces during construction.'
    },
    {
      question: 'How do I choose between repair and full replacement?',
      answer: 'Consider the age and condition of existing features, your budget, and long-term plans. If cabinets, fixtures, or systems are over 20 years old or showing significant wear, replacement often makes more sense than repairs. Remodeling allows you to update to energy-efficient options and modern designs. A quality contractor will honestly assess whether repair or replacement provides better value for your situation.'
    },
    {
      question: 'What should I do to prepare for a remodeling project?',
      answer: 'Clear the work area of personal items and furniture. Set up temporary kitchen or bathroom facilities if needed. Establish a communication plan with your contractor. Protect flooring in traffic areas. Inform neighbors about the project timeline. Create a designated area for contractor materials and tools. Most importantly, maintain realistic expectations—remodeling is disruptive but the results are worth the temporary inconvenience.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about remodeling projects in El Paso answered by local experts.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
              <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-100 transition-colors">
                <h3 className="text-lg font-bold text-gray-900 pr-4">{faq.question}</h3>
                <i className="ri-arrow-down-s-line text-2xl text-gray-600 group-open:rotate-180 transition-transform flex-shrink-0"></i>
              </summary>
              <div className="px-6 pb-6">
                <p className="text-sm text-gray-700 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>

        <div className="mt-12 text-center bg-teal-50 rounded-xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            Still Have Questions?
          </h3>
          <p className="text-gray-700 mb-6">
            Connect with experienced remodeling contractors who can provide personalized answers for your specific project.
          </p>
          <a href="#directory" className="inline-block px-8 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap">
            Contact a Contractor
          </a>
        </div>
      </div>
    </section>
  );
}
